Fundu.Helpers.Formats = (function ($) {

    // https://stackoverflow.com/a/2901298
    var formatCurrency = function (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    var getNumberValue = function (element) {
        return parseFloat(element.text().replace(/\s+/g, ''))
    }

    return {
        formatCurrency: formatCurrency,
        getNumberValue: getNumberValue
    }

})();
